import { create } from 'ackee-http-client';

import config from 'Config';

const { api, saga } = create(
    {
        baseURL: config.api.base,
    },
    {
        managaAuthUser: false,
    },
);

export { api, saga };
